import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ChainedBackend from "i18next-chained-backend";
import HttpBackend from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const options = {
  fallbackLng: "en",
  supportedLngs: ["pl", "en"],
  load: "languageOnly", // we only provide en, de -> no region specific locals like en-US, de-DE
  ns: ["global", "Pages", "Components", "Notifications"],
  defaultNS: "global",

  saveMissing: true,
  debug: false,

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ",",
    format: (value: string, format: string) => {
      if (format === "uppercase") return value.toUpperCase();
      return value;
    },
  },
  useSuspense: false,
  backend: {
    backends: [LocalStorageBackend, HttpBackend],
    backendOptions: [
      {
        expirationTime: 60 * 1000, // 1 minute
      },
      {
        addPath:
          "https://api.breward.app/api/v1/translations/add/{{lng}}/{{ns}}",
        loadPath: "https://api.breward.app/api/v1/translations/{{lng}}/{{ns}}",
      },
      // {
      //   addPath: "http://localhost:4000/api/v1/translations/add/{{lng}}/{{ns}}",
      //   loadPath: "http://localhost:4000/api/v1/translations/{{lng}}/{{ns}}",
      // },
    ],
  },
};

i18n
  .use(ChainedBackend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init(options);

export default i18n;
